export const styles = {
  loading: {
    width: '1.25rem',
    height: '1.25rem',
  },
};
